<script>
import appConfig from "@/app.config";
import NetProviderForm from "@/components/net-providers/Form";

export default {
  page: {
    title: "ثبت ارائه دهنده جدید",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    NetProviderForm,
  },
  props: {
    application: Object,
  },
  data() {
    return {
      items: [
        {
          text: "لیست ارائه دهندگان اینترنت موبایل",
          to: { name: "net-providers" },
        },
        {
          text: "ثبت ارائه دهنده جدید",
          active: true,
        },
      ],
      title: "",
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div>
      <div class="row px-0">
        <div class="col-12 px-0">
          <div class="card px-0">
            <div class="card-body">
              <NetProviderForm :id="$route.params.id" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
